/**
 * Curated bubble color palette. Picked for aura-shader contrast on both
 * light and dark backgrounds.
 */
export const BUBBLE_COLORS = {
    violet: "#7200E1",
    cobalt: "#2563EB",
    teal: "#0891B2",
    emerald: "#10B981",
    coral: "#F43F5E",
    amber: "#F59E0B",
};
const HEX = /^#(?:[0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/;
export function resolveBubbleColor(value) {
    if (!value)
        return BUBBLE_COLORS.violet;
    if (value.startsWith("#")) {
        if (!HEX.test(value))
            return BUBBLE_COLORS.violet;
        let h = value.slice(1);
        if (h.length === 3)
            h = h
                .split("")
                .map((c) => c + c)
                .join("");
        return `#${h.toUpperCase()}`;
    }
    return BUBBLE_COLORS[value] ?? BUBBLE_COLORS.violet;
}
